export const SET_EMPRESA = "SET_EMPRESA";
